// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3pAOQ","modalForm":"UpgradeEpcsModal_modalForm__3X1ph","modalFooter":"UpgradeEpcsModal_modalFooter__3YKud"};